import { inject, Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, race, switchMap, take, throwError } from 'rxjs';
import type { Observable } from 'rxjs';

import { SkillsIdeateActions } from '@core/tellent-skills-data';
import type { SkillsIdeate, SkillsIdeateStartParams } from '@core/tellent-skills-types';

@Injectable({ providedIn: 'root' })
export class SkillsIdeateDataFacade {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  public startIdeate(params: SkillsIdeateStartParams): Observable<SkillsIdeate> {
    this.store.dispatch(SkillsIdeateActions.startIdeate({ payload: params }));

    return race(
      this.actions$.pipe(
        ofType(SkillsIdeateActions.startIdeateSuccess),
        map(({ payload }) => payload.data),
      ),
      this.actions$.pipe(
        ofType(SkillsIdeateActions.startIdeateFailed),
        switchMap(({ payload }) => throwError(() => payload)),
      ),
    ).pipe(take(1));
  }

  public fetchIdeate(id: number): Observable<SkillsIdeate> {
    this.store.dispatch(SkillsIdeateActions.fetchIdeate({ payload: { id } }));

    return race(
      this.actions$.pipe(
        ofType(SkillsIdeateActions.fetchIdeateSuccess),
        map(({ payload }) => payload.data),
      ),
      this.actions$.pipe(
        ofType(SkillsIdeateActions.fetchIdeateFailed),
        switchMap(({ payload }) => throwError(() => payload)),
      ),
    ).pipe(take(1));
  }
}
